"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _FormLabel = _interopRequireDefault(require("@mui/material/FormLabel"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormGroup = _interopRequireDefault(require("@mui/material/FormGroup"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));
var _Chip = _interopRequireDefault(require("@mui/material/Chip"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _TextInput = _interopRequireDefault(require("../../../components/TextFields/TextInput"));
var _NumberInput = _interopRequireDefault(require("../../../components/TextFields/NumberInput"));
var _DateInput = _interopRequireDefault(require("../../../components/TextFields/DateInput"));
var _FormModal = _interopRequireDefault(require("../../../components/Modals/FormModal"));
var _StepCompletionNotif = _interopRequireDefault(require("../../../components/Modals/StepCompletionNotif"));
var _MessageCard = _interopRequireDefault(require("../../../components/Cards/MessageCard"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _Button = _interopRequireDefault(require("../../../components/Button"));
var _Checkbox = _interopRequireDefault(require("../../../components/Checkbox"));
var _ = require("../../..");
var _DisplayBankingDetails = _interopRequireDefault(require("../../../components/DisplayBankingDetails"));
var _SurvivorBenefitDependentRow = _interopRequireDefault(require("./SurvivorBenefitDependentRow"));
var _EmployeeNotAtWorkRow = _interopRequireDefault(require("./EmployeeNotAtWorkRow"));
var _ContractEmployeeRow = _interopRequireDefault(require("./ContractEmployeeRow"));
var _ExcludedFromBenefitsRow = _interopRequireDefault(require("./ExcludedFromBenefitsRow"));
var _ExistingCoverageBlock = _interopRequireDefault(require("./ExistingCoverageBlock"));
var _LsaSelectionModal = _interopRequireDefault(require("../../../components/Modals/LsaSelectionModal"));
var Services = _interopRequireWildcard(require("../../../services"));
var Theme = _interopRequireWildcard(require("../../../theme"));
var _colors = _interopRequireDefault(require("../../../theme/colors"));
var _helpers = require("../../../services/helpers");
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
var localizationMaps = _interopRequireWildcard(require("../../../localization/maps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // React and Material-UI imports
// Material-UI Icons and Components
// External Libraries
// Custom Components
// Services and Themes
// Localization
var MasterAppForm = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(MasterAppForm, _PureComponent);
  function MasterAppForm() {
    var _this;
    (0, _classCallCheck2["default"])(this, MasterAppForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, MasterAppForm, [].concat(args)), _this.state = {
      company: _this.props.data.company || '',
      address: (0, _helpers.translateAddress)(_this.props.data.address) || '',
      categories: _this.props.data.categories,
      nature: _this.props.data.nature || '',
      numLives: _this.props.data.numLives || 0,
      hasExistingCoverage: _this.props.data.hasExistingCoverage || false,
      existingCoverage: _this.props.data.existingCoverage || [],
      numEmployeesInsured: _this.props.data.numEmployeesInsured || 0,
      numEmployeesCoveredByWCB: _this.props.data.numEmployeesCoveredByWCB || 0,
      dependentsWithSurvivorBenefits: _this.props.data.dependentsWithSurvivorBenefits ? _this.props.data.dependentsWithSurvivorBenefits.map(function (dependent) {
        return _objectSpread(_objectSpread({}, dependent), {}, {
          expiryDate: Services.dates.formatIncomingDate(dependent.expiryDate)
        });
      }) : [],
      employeesNotActivelyAtWork: _this.props.data.employeesNotActivelyAtWork ? _this.props.data.employeesNotActivelyAtWork.map(function (employee) {
        return _objectSpread(_objectSpread({}, employee), {}, {
          dateLastAtWork: Services.dates.formatIncomingDate(employee.dateLastAtWork),
          expectedReturnDate: Services.dates.formatIncomingDate(employee.expectedReturnDate)
        });
      }) : [],
      contractEmployees: _this.props.data.contractEmployees ? _this.props.data.contractEmployees.map(function (employee) {
        return _objectSpread(_objectSpread({}, employee), {}, {
          contractEndDate: Services.dates.formatIncomingDate(employee.contractEndDate),
          contractStartDate: Services.dates.formatIncomingDate(employee.contractStartDate)
        });
      }) : [],
      exclusionsFromCoverage: _this.props.data.exclusionsFromCoverage || [],
      stopLoss: {
        status: _this.props.data.stopLoss.status || false,
        amount: _this.props.data.stopLoss.amount || 0,
        insuredsWithRecurringClaims: _this.props.data.stopLoss.insuredsWithRecurringClaims || false
      },
      notes: _this.props.data.notes || '',
      signage: {
        advisor: {
          name: _this.props.data.signage.advisor.name || '',
          signature: _this.props.data.signage.advisor.signature || '',
          acceptedTerms: _this.props.data.signage.advisor.acceptedTerms || false,
          timestampOfAcceptance: _this.props.data.signage.advisor.timestampOfAcceptance || null,
          datedOn: _this.props.data.signage.advisor.datedOn ? Services.dates.formatIncomingDate(_this.props.data.signage.advisor.datedOn) : null
        },
        authority: {
          name: _this.props.data.signage.authority.name || '',
          signature: _this.props.data.signage.authority.signature || '',
          acceptedTerms: _this.props.data.signage.authority.acceptedTerms || false,
          timestampOfAcceptance: _this.props.data.signage.authority.timestampOfAcceptance || null,
          datedOn: _this.props.data.signage.authority.datedOn ? Services.dates.formatIncomingDate(_this.props.data.signage.authority.datedOn) : null
        },
        witness: {
          name: _this.props.data.signage.witness.name || '',
          signature: _this.props.data.signage.witness.signature || '',
          acceptedTerms: _this.props.data.signage.witness.acceptedTerms || false,
          timestampOfAcceptance: _this.props.data.signage.witness.timestampOfAcceptance || null,
          datedOn: _this.props.data.signage.witness.datedOn ? Services.dates.formatIncomingDate(_this.props.data.signage.witness.datedOn) : null
        }
      },
      bankingModal: false,
      eftDetails: {
        "default": {
          // if the account is in Revision, just set some default values so the request goes through, we don't save this data for Revisions,
          // set everything in "default" to match the data format used in every other banking details modal
          accountHolder: _this.props.currentAccountMeta.status === 3 ? 'N/A' : '',
          institutionName: _this.props.currentAccountMeta.status === 3 ? 'N/A' : '',
          institutionAddress: _this.props.currentAccountMeta.status === 3 ? 'N/A' : '',
          institutionNum: _this.props.currentAccountMeta.status === 3 ? '123' : '',
          transitNum: _this.props.currentAccountMeta.status === 3 ? '12345' : '',
          accountNum: _this.props.currentAccountMeta.status === 3 ? '12345678' : '',
          isValidated: false,
          accepted: _this.props.currentAccountMeta.status === 3,
          timestampOfAcceptance: _this.props.currentAccountMeta.status === 3 ? 1 : null,
          accountHolderError: false,
          institutionNumError: false,
          transitNumError: false,
          accountNumError: false,
          acceptedError: false,
          branchValidationError: false
        }
      },
      modalTypeOpen: false,
      modalTitle: '',
      isEdit: false,
      currentItem: null,
      appSubmitted: false,
      reviewRequestSentSuccessDialogOpen: false,
      lsaModal: false,
      lsaItems: _this.props.data.lsaItems || null,
      hasLsa: false,
      errors: {},
      locale: _i18n["default"].locale
    }, _this._timer = null, _this._validateMasterForm = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var isValid, fieldsToCheck, stopLossAmountError;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            isValid = true;
            fieldsToCheck = ['company', 'numLives', 'address', 'nature', 'categories', 'numEmployeesInsured', 'numEmployeesCoveredByWCB'];
            _context2.next = 4;
            return fieldsToCheck.map( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(field) {
                var error;
                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      error = false; // We don't need to check certain fields if certain checkmarks aren't checked
                      if (!(field === 'numEmployeesInsured' || field === 'numEmployeesCoveredByWCB')) {
                        _context.next = 5;
                        break;
                      }
                      if (!_this.state.hasExistingCoverage) {
                        // Make sure the fields are set back to a number
                        _this.setState((0, _defineProperty2["default"])({}, field, 0));
                      } else {
                        // Make sure the value is a number
                        error = isNaN(_this.state[field]) ? _i18n["default"].t(_tokens["default"].labels.validations.pleaseEnterValidNumber) : false;
                      }
                      _context.next = 8;
                      break;
                    case 5:
                      _context.next = 7;
                      return Services.validateInput('checkEmpty', _this.state[field]);
                    case 7:
                      error = _context.sent;
                    case 8:
                      if (error) {
                        isValid = false;
                        _this.setState({
                          errors: _objectSpread(_objectSpread({}, _this.state.errors), {}, (0, _defineProperty2["default"])({}, "".concat(field, "Error"), field === 'categories' ? _i18n["default"].t(_tokens["default"].labels.validations.pleaseSelectAtLeastOne) : error))
                        });
                      }
                      return _context.abrupt("return", true);
                    case 10:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }());
          case 4:
            if (!_this.state.stopLoss.status) {
              _context2.next = 11;
              break;
            }
            _context2.next = 7;
            return Services.validateInput('checkEmpty', _this.state.stopLoss.amount);
          case 7:
            stopLossAmountError = _context2.sent;
            if (stopLossAmountError) {
              // Let the user know that the stop loss amount is required
              _this.setState({
                errors: _objectSpread(_objectSpread({}, _this.state.errors), {}, {
                  stopLossAmountError: stopLossAmountError
                })
              });
              isValid = false;
            }
            _context2.next = 12;
            break;
          case 11:
            // Make sure stoploss amount isn't an empty string
            _this.setState({
              stopLoss: _objectSpread(_objectSpread({}, _this.state.stopLoss), {}, {
                amount: 0
              })
            });
          case 12:
            if (_this.state.hasExistingCoverage && _this.state.existingCoverage.length === 0) {
              // Let the user know that the stop loss amount is required
              _this.setState({
                errors: _objectSpread(_objectSpread({}, _this.state.errors), {}, {
                  existingCarrierError: _i18n["default"].t(_tokens["default"].labels.validations.existingCarrier)
                })
              });
              isValid = false;
            }
            return _context2.abrupt("return", isValid);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), _this._validateSignageBlock = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var requiresSignageBlock, isAuthorityView, advisorAcceptedTermsError, authorityAcceptedTermsError, witnessAcceptedTermsError, acceptedBankingTermsError, isBankingValid, advisorSignatureError, advisorNameError, advisorDatedOnError, authoritySignatureError, authorityNameError, authorityDatedOnError, witnessSignatureError, witnessNameError, witnessDatedOnError;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            requiresSignageBlock = _this.props.isPrivateLabelAdvisor || _this.props.currentAccountMeta.state >= 6;
            if (requiresSignageBlock) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return", true);
          case 3:
            isAuthorityView = _this.props.isAuthorityView;
            advisorAcceptedTermsError = isAuthorityView ? null : !_this.state.signage.advisor.acceptedTerms;
            authorityAcceptedTermsError = isAuthorityView ? !_this.state.signage.authority.acceptedTerms : null;
            witnessAcceptedTermsError = isAuthorityView ? !_this.state.signage.witness.acceptedTerms : null;
            acceptedBankingTermsError = isAuthorityView ? !_this.state.eftDetails["default"].accepted : null;
            isBankingValid = true; // validate the banking details
            if (isAuthorityView && _this.props.currentAccountMeta.status !== 3) {
              isBankingValid = _this.state.eftDetails["default"].accepted;
            }
            if (isBankingValid) {
              _context3.next = 14;
              break;
            }
            _context3.next = 13;
            return _this.props.displayError({
              verbiage: _i18n["default"].t(_tokens["default"].labels.validations.bankingDetailsCorrectlyFilledOut)
            });
          case 13:
            return _context3.abrupt("return", false);
          case 14:
            if (!isAuthorityView) {
              _context3.next = 18;
              break;
            }
            _context3.t0 = null;
            _context3.next = 21;
            break;
          case 18:
            _context3.next = 20;
            return Services.validateInput('checkEmpty', _this.state.signage.advisor.signature);
          case 20:
            _context3.t0 = _context3.sent;
          case 21:
            advisorSignatureError = _context3.t0;
            if (!isAuthorityView) {
              _context3.next = 26;
              break;
            }
            _context3.t1 = null;
            _context3.next = 29;
            break;
          case 26:
            _context3.next = 28;
            return Services.validateInput('checkEmpty', _this.state.signage.advisor.name);
          case 28:
            _context3.t1 = _context3.sent;
          case 29:
            advisorNameError = _context3.t1;
            if (!isAuthorityView) {
              _context3.next = 34;
              break;
            }
            _context3.t2 = null;
            _context3.next = 37;
            break;
          case 34:
            _context3.next = 36;
            return Services.validateInput('date', _this.state.signage.advisor.datedOn, _i18n["default"].locale);
          case 36:
            _context3.t2 = _context3.sent;
          case 37:
            advisorDatedOnError = _context3.t2;
            if (!isAuthorityView) {
              _context3.next = 44;
              break;
            }
            _context3.next = 41;
            return Services.validateInput('checkEmpty', _this.state.signage.authority.signature);
          case 41:
            _context3.t3 = _context3.sent;
            _context3.next = 45;
            break;
          case 44:
            _context3.t3 = null;
          case 45:
            authoritySignatureError = _context3.t3;
            if (!isAuthorityView) {
              _context3.next = 52;
              break;
            }
            _context3.next = 49;
            return Services.validateInput('checkEmpty', _this.state.signage.authority.name);
          case 49:
            _context3.t4 = _context3.sent;
            _context3.next = 53;
            break;
          case 52:
            _context3.t4 = null;
          case 53:
            authorityNameError = _context3.t4;
            if (!isAuthorityView) {
              _context3.next = 60;
              break;
            }
            _context3.next = 57;
            return Services.validateInput('date', _this.state.signage.authority.datedOn, _i18n["default"].locale);
          case 57:
            _context3.t5 = _context3.sent;
            _context3.next = 61;
            break;
          case 60:
            _context3.t5 = null;
          case 61:
            authorityDatedOnError = _context3.t5;
            if (!isAuthorityView) {
              _context3.next = 68;
              break;
            }
            _context3.next = 65;
            return Services.validateInput('checkEmpty', _this.state.signage.witness.signature);
          case 65:
            _context3.t6 = _context3.sent;
            _context3.next = 69;
            break;
          case 68:
            _context3.t6 = null;
          case 69:
            witnessSignatureError = _context3.t6;
            if (!isAuthorityView) {
              _context3.next = 76;
              break;
            }
            _context3.next = 73;
            return Services.validateInput('checkEmpty', _this.state.signage.witness.name);
          case 73:
            _context3.t7 = _context3.sent;
            _context3.next = 77;
            break;
          case 76:
            _context3.t7 = null;
          case 77:
            witnessNameError = _context3.t7;
            if (!isAuthorityView) {
              _context3.next = 84;
              break;
            }
            _context3.next = 81;
            return Services.validateInput('date', _this.state.signage.witness.datedOn, _i18n["default"].locale);
          case 81:
            _context3.t8 = _context3.sent;
            _context3.next = 85;
            break;
          case 84:
            _context3.t8 = null;
          case 85:
            witnessDatedOnError = _context3.t8;
            if (!isAuthorityView && _this.state.signage.advisor.signature !== '' && _this.state.signage.advisor.name !== '' && _this.state.signage.advisor.signature.trim() !== _this.state.signage.advisor.name.trim()) {
              advisorSignatureError = _i18n["default"].t(_tokens["default"].labels.signage.advisorSignageError);
            }
            if (isAuthorityView && _this.state.signage.authority.signature !== '' && _this.state.signage.authority.name !== '' && _this.state.signage.authority.signature.trim() !== _this.state.signage.authority.name.trim()) {
              authoritySignatureError = _i18n["default"].t(_tokens["default"].labels.signage.authoritySignageError);
            }
            if (isAuthorityView && _this.state.signage.witness.signature !== '' && _this.state.signage.witness.name !== '' && _this.state.signage.witness.signature.trim() !== _this.state.signage.witness.name.trim()) {
              witnessSignatureError = _i18n["default"].t(_tokens["default"].labels.signage.advisorSignageError);
            }

            // only need the banking details if it's the authority view and not for Revision
            if (!(isAuthorityView && _this.props.currentAccountMeta.status !== 3)) {
              _context3.next = 94;
              break;
            }
            _context3.next = 92;
            return _this.setState({
              errors: _objectSpread(_objectSpread({}, _this.state.errors), {}, {
                authoritySignatureError: authoritySignatureError || null,
                authorityNameError: authorityNameError || null,
                authorityDatedOnError: authorityDatedOnError || null,
                witnessSignatureError: witnessSignatureError || null,
                witnessNameError: witnessNameError || null,
                witnessDatedOnError: witnessDatedOnError || null,
                authorityAcceptedTermsError: authorityAcceptedTermsError,
                witnessAcceptedTermsError: witnessAcceptedTermsError,
                acceptedBankingTermsError: acceptedBankingTermsError
              })
            });
          case 92:
            _context3.next = 96;
            break;
          case 94:
            _context3.next = 96;
            return _this.setState({
              errors: _objectSpread(_objectSpread({}, _this.state.errors), {}, {
                advisorSignatureError: advisorSignatureError || null,
                advisorNameError: advisorNameError || null,
                advisorDatedOnError: advisorDatedOnError || null,
                advisorAcceptedTermsError: advisorAcceptedTermsError
              })
            });
          case 96:
            if (!(advisorSignatureError || advisorNameError || advisorDatedOnError || advisorAcceptedTermsError || authoritySignatureError || authorityNameError || authorityDatedOnError || authorityAcceptedTermsError || witnessSignatureError || witnessNameError || witnessDatedOnError || witnessAcceptedTermsError || acceptedBankingTermsError)) {
              _context3.next = 99;
              break;
            }
            window.scroll(0, 5000);
            return _context3.abrupt("return", false);
          case 99:
            _this.setState({
              errors: {}
            });
            return _context3.abrupt("return", true);
          case 101:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), _this._completeMasterApp = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var isValid, success;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _this._validateSignageBlock();
          case 2:
            isValid = _context4.sent;
            if (isValid) {
              _context4.next = 5;
              break;
            }
            return _context4.abrupt("return", false);
          case 5:
            _context4.next = 7;
            return _this.props.completeMasterApp(_this.props.currentAccountMeta.accountID);
          case 7:
            success = _context4.sent;
            if (success) {
              _context4.next = 10;
              break;
            }
            return _context4.abrupt("return", false);
          case 10:
            _this.setState({
              reviewRequestSentSuccessDialogOpen: true
            });
            return _context4.abrupt("return", true);
          case 12:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })), _this._onBlur = /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(type) {
        var newValue;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              newValue = type === 'stopLossAmount' ? _this.state.stopLoss.amount : _this.state[type];
              _context5.t0 = _this;
              _context5.t1 = _objectSpread;
              _context5.t2 = _objectSpread({}, _this.state.errors);
              _context5.t3 = {};
              _context5.t4 = _defineProperty2["default"];
              _context5.t5 = {};
              _context5.t6 = "".concat(type, "Error");
              _context5.next = 10;
              return Services.validateInput('checkEmpty', newValue);
            case 10:
              _context5.t7 = _context5.sent;
              _context5.t8 = (0, _context5.t4)(_context5.t5, _context5.t6, _context5.t7);
              _context5.t9 = (0, _context5.t1)(_context5.t2, _context5.t3, _context5.t8);
              _context5.t10 = {
                errors: _context5.t9
              };
              _context5.t0.setState.call(_context5.t0, _context5.t10);
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }(), _this._onBlurDate = function (type, noFuture) {
      var isCurrentModal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!isCurrentModal) {
        _this.setState({
          errors: _objectSpread(_objectSpread({}, _this.state.errors), {}, (0, _defineProperty2["default"])({}, "".concat(type, "Error"), Services.dates.validateDate(_this.state.currentItem[type], noFuture)))
        });
      } else {
        _this.setState({
          errors: {
            currentModal: _objectSpread(_objectSpread({}, _this.state.errors.currentModal), {}, (0, _defineProperty2["default"])({}, "".concat(type, "Error"), Services.dates.validateDate(_this.state.currentItem[type], noFuture)))
          }
        });
      }
    }, _this._handleChange = function (prop, subProp) {
      return function (event) {
        _this._checkSignatureBlock();
        if (!subProp) {
          _this.setState((0, _defineProperty2["default"])({}, prop, event.target.value));
        } else {
          _this.setState((0, _defineProperty2["default"])({}, prop, _objectSpread(_objectSpread({}, _this.state[prop]), {}, (0, _defineProperty2["default"])({}, subProp, event.target.value))));
        }
      };
    }, _this._toggle = function (prop, subProp) {
      _this._checkSignatureBlock();
      if (!subProp) {
        _this.setState((0, _defineProperty2["default"])({}, prop, !_this.state[prop]));
      } else {
        _this.setState((0, _defineProperty2["default"])({}, prop, _objectSpread(_objectSpread({}, _this.state[prop]), {}, (0, _defineProperty2["default"])({}, subProp, !_this.state[prop][subProp]))));
      }
    }, _this.saveLsaItems = function (items) {
      if (items.length) {
        _this.setState({
          lsaItems: (0, _toConsumableArray2["default"])(items)
        });
      }
      return true;
    }, _this._removeLsaItem = function (item) {
      _this.setState({
        lsaItems: (0, _toConsumableArray2["default"])(_this.state.lsaItems.filter(function (x) {
          return x !== item;
        }))
      });
    }, _this._toggleModal = function (state) {
      _this.setState({
        modalTypeOpen: state
      });
    }, _this._handleCategoryChange = function (category) {
      _this._checkSignatureBlock();
      var index = _this.state.categories.indexOf(category);
      if (index === -1) {
        _this.setState({
          categories: [category].concat((0, _toConsumableArray2["default"])(_this.state.categories)),
          errors: _objectSpread(_objectSpread({}, _this.state.errors), {}, {
            categoriesError: false
          })
        });
      } else {
        _this.setState({
          categories: _this.state.categories.slice(0, index).concat(_this.state.categories.slice(index + 1, _this.state.categories.length))
        });
      }
    }, _this._openModal = /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(type) {
        var isEdit,
          uuid,
          currentItem,
          modalTitle,
          _yield$_this$state$ty,
          _yield$_this$state$ty2,
          _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              isEdit = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
              uuid = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : false;
              if (!(_this.props.isAuthorityView || _this.props.isReadOnly)) {
                _context6.next = 4;
                break;
              }
              return _context6.abrupt("return", null);
            case 4:
              _this._save();
              currentItem = {};
              modalTitle = '';
              if (type === 'dependentsWithSurvivorBenefits') {
                modalTitle = _i18n["default"].t(_tokens["default"].labels.masterApplication.dependentSurvivorBenefit);
                currentItem = {
                  name: '',
                  expiryDate: ''
                };
              } else if (type === 'employeesNotActivelyAtWork') {
                modalTitle = _i18n["default"].t(_tokens["default"].labels.masterApplication.employeeNoWork);
                currentItem = {
                  name: '',
                  dateLastAtWork: '',
                  expectedReturnDate: '',
                  reasonNotAtWork: '',
                  claimStatus: ''
                };
              } else if (type === 'contractEmployees') {
                modalTitle = _i18n["default"].t(_tokens["default"].labels.masterApplication.contractEmployeeSingle);
                currentItem = {
                  name: '',
                  occupation: '',
                  contractStartDate: '',
                  contractEndDate: ''
                };
              } else if (type === 'exclusionsFromCoverage') {
                modalTitle = _i18n["default"].t(_tokens["default"].labels.masterApplication.excludedEmployee);
                currentItem = {
                  name: '',
                  reasonForExclusion: ''
                };
              } else if (type === 'existingCoverage') {
                modalTitle = _i18n["default"].t(_tokens["default"].labels.masterApplication.existingCarrier);
                currentItem = {
                  carrier: '',
                  benefits: []
                };
              }

              // if its an edit, find the item using the provided uuid
              if (!(isEdit && uuid)) {
                _context6.next = 15;
                break;
              }
              modalTitle = "Edit ".concat(modalTitle);
              _context6.next = 12;
              return _this.state[type].filter(function (record) {
                return record.uuid === uuid;
              });
            case 12:
              _yield$_this$state$ty = _context6.sent;
              _yield$_this$state$ty2 = (0, _slicedToArray2["default"])(_yield$_this$state$ty, 1);
              currentItem = _yield$_this$state$ty2[0];
            case 15:
              _this.setState({
                modalTypeOpen: type,
                isEdit: isEdit,
                currentItem: currentItem,
                modalTitle: modalTitle
              });
              return _context6.abrupt("return", null);
            case 17:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x3) {
        return _ref6.apply(this, arguments);
      };
    }(), _this._closeModal = function () {
      _this.setState({
        modalTypeOpen: false,
        isEdit: false,
        errors: _objectSpread(_objectSpread({}, _this.state.errors), {}, {
          currentModal: {}
        })
      });
    }, _this._checkSignatureBlock = function () {
      var requiresSignageBlock = _this.props.currentAccountMeta.state >= 6;
      if (!requiresSignageBlock) {
        return null;
      }
      if (_this.props.isAuthorityView) {
        return null;
      }
      if (_this.state.signage.advisor.signature !== '' || _this.state.signage.advisor.acceptedTerms) {
        _this.setState({
          signage: _objectSpread(_objectSpread({}, _this.state.signage), {}, {
            advisor: _objectSpread(_objectSpread({}, _this.state.signage.advisor), {}, {
              signature: '',
              acceptedTerms: false,
              datedOn: null
            })
          })
        });
      }
      return null;
    }, _this._closeReviewRequestSentSuccessDialog = function () {
      _this.setState({
        reviewRequestSentSuccessDialogOpen: false
      });
      _this._goToNextStep();
    }, _this._goToNextStep = function () {
      _this.props.setSelectedSection(false);
    }, _this._modalFormItemBlur = /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(type) {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.t0 = _this;
              _context7.t1 = _objectSpread;
              _context7.t2 = _objectSpread({}, _this.state.errors.currentModal);
              _context7.t3 = {};
              _context7.t4 = _defineProperty2["default"];
              _context7.t5 = {};
              _context7.t6 = "".concat(type, "Error");
              _context7.next = 9;
              return Services.validateInput("checkEmpty", _this.state.currentItem[type]);
            case 9:
              _context7.t7 = _context7.sent;
              _context7.t8 = (0, _context7.t4)(_context7.t5, _context7.t6, _context7.t7);
              _context7.t9 = (0, _context7.t1)(_context7.t2, _context7.t3, _context7.t8);
              _context7.t10 = {
                currentModal: _context7.t9
              };
              _context7.t11 = {
                errors: _context7.t10
              };
              _context7.t0.setState.call(_context7.t0, _context7.t11);
            case 15:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function (_x4) {
        return _ref7.apply(this, arguments);
      };
    }(), _this._handleModalFormItemChange = function (field, subField) {
      return function (e) {
        _this._checkSignatureBlock();
        if (_this.state.modalTypeOpen === 'existingCoverage' && field === 'benefits') {
          var index = _this.state.currentItem.benefits.indexOf(subField);
          var items = _this.state.currentItem.benefits;
          _this.setState({
            currentItem: _objectSpread(_objectSpread({}, _this.state.currentItem), {}, {
              benefits: index === -1 ? [subField].concat((0, _toConsumableArray2["default"])(_this.state.currentItem.benefits)) : items.slice(0, index).concat(items.slice(index + 1, items.length))
            }),
            errors: {
              currentModal: _objectSpread(_objectSpread({}, _this.state.errors.currentModal), {}, {
                benefitsError: false
              })
            }
          });
        } else {
          _this.setState({
            currentItem: _objectSpread(_objectSpread({}, _this.state.currentItem), {}, (0, _defineProperty2["default"])({}, field, e.target.value))
          });
        }
      };
    }, _this._handleSignageBlockChange = function (prop, subProp, value) {
      var requiresSignageBlock = _this.props.isPrivateLabelAdvisor || _this.props.currentAccountMeta.state >= 6;
      if (!requiresSignageBlock) {
        return null;
      }
      if (subProp === 'acceptedTerms' && value === true) {
        _this.setState({
          signage: _objectSpread(_objectSpread({}, _this.state.signage), {}, (0, _defineProperty2["default"])({}, prop, _objectSpread(_objectSpread({}, _this.state.signage[prop]), {}, {
            acceptedTerms: true,
            timestampOfAcceptance: dates.getUTC()
          })))
        });
        return null;
      }
      _this.setState({
        signage: _objectSpread(_objectSpread({}, _this.state.signage), {}, (0, _defineProperty2["default"])({}, prop, _objectSpread(_objectSpread({}, _this.state.signage[prop]), {}, (0, _defineProperty2["default"])({}, subProp, value))))
      });
      return null;
    }, _this._addArrayItem = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
      var type, item, itemKeys, isInvalid;
      return _regenerator["default"].wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            type = _this.state.modalTypeOpen;
            item = _this.state.currentItem;
            itemKeys = Object.keys(item);
            isInvalid = false; // Validate the form
            _context9.next = 6;
            return itemKeys.map( /*#__PURE__*/function () {
              var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(key) {
                var error;
                return _regenerator["default"].wrap(function _callee8$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      error = '';
                      _context8.t0 = key;
                      _context8.next = _context8.t0 === ('expiryDate' || 'expectedReturnDate' || 'contractEndDate') ? 4 : _context8.t0 === ('dateLastAtWork' || 'contractStartDate') ? 6 : 8;
                      break;
                    case 4:
                      error = Services.dates.validateDate(item[key], false);
                      return _context8.abrupt("break", 12);
                    case 6:
                      error = Services.dates.validateDate(item[key]);
                      return _context8.abrupt("break", 12);
                    case 8:
                      _context8.next = 10;
                      return Services.validateInput("checkEmpty", item[key]);
                    case 10:
                      error = _context8.sent;
                      return _context8.abrupt("break", 12);
                    case 12:
                      if (error) {
                        isInvalid = true;

                        // Set error for input too
                        _this.setState({
                          errors: {
                            currentModal: _objectSpread(_objectSpread({}, _this.state.errors.currentModal), {}, (0, _defineProperty2["default"])({}, "".concat(key, "Error"), key === 'benefits' ? 'Please select at least one' : error))
                          }
                        });
                      }
                      return _context8.abrupt("return", true);
                    case 14:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              }));
              return function (_x5) {
                return _ref9.apply(this, arguments);
              };
            }());
          case 6:
            if (!isInvalid) {
              // add a unique identifier just for removing and editing
              item.uuid = new Date().getTime();
              _this.setState((0, _defineProperty2["default"])({}, type, [item].concat((0, _toConsumableArray2["default"])(_this.state[type]))));
              _this._save();
              _this._closeModal();
            }
          case 7:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    })), _this._updateArrayItem = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
      var type, item, itemKeys, isInvalid;
      return _regenerator["default"].wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            type = _this.state.modalTypeOpen;
            item = _this.state.currentItem;
            itemKeys = Object.keys(item);
            isInvalid = false; // Validate the form
            _context11.next = 6;
            return itemKeys.map( /*#__PURE__*/function () {
              var _ref11 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(key) {
                return _regenerator["default"].wrap(function _callee10$(_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                      _context10.t0 = key;
                      _context10.next = _context10.t0 === 'expiryDate' ? 3 : 5;
                      break;
                    case 3:
                      isInvalid = Services.dates.validateDate(item[key], false) ? true : isInvalid;
                      return _context10.abrupt("break", 14);
                    case 5:
                      _context10.next = 7;
                      return Services.validateInput("checkEmpty", item[key]);
                    case 7:
                      if (!_context10.sent) {
                        _context10.next = 11;
                        break;
                      }
                      _context10.t1 = true;
                      _context10.next = 12;
                      break;
                    case 11:
                      _context10.t1 = isInvalid;
                    case 12:
                      isInvalid = _context10.t1;
                      return _context10.abrupt("break", 14);
                    case 14:
                      return _context10.abrupt("return", true);
                    case 15:
                    case "end":
                      return _context10.stop();
                  }
                }, _callee10);
              }));
              return function (_x6) {
                return _ref11.apply(this, arguments);
              };
            }());
          case 6:
            if (!isInvalid) {
              _this.setState((0, _defineProperty2["default"])({}, type, _this.state[type].map(function (record) {
                if (record.uuid !== item.uuid) {
                  return record;
                }
                return item;
              })));
              _this._save();
              _this._closeModal();
            }
          case 7:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    })), _this._removeArrayItem = function (type, uuid) {
      _this.setState((0, _defineProperty2["default"])({}, type, _this.state[type].filter(function (record) {
        return record.uuid !== uuid;
      })));
    }, _this._save = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
      var showLoader,
        showSuccess,
        isSubmit,
        isSigningValid,
        isFormValid,
        data,
        success,
        _args12 = arguments;
      return _regenerator["default"].wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            showLoader = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : false;
            showSuccess = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : true;
            isSubmit = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : false;
            if (!_this.props.isReadOnly) {
              _context12.next = 5;
              break;
            }
            return _context12.abrupt("return", false);
          case 5:
            isSigningValid = true; // Only validate signage on submit
            if (!isSubmit) {
              _context12.next = 10;
              break;
            }
            _context12.next = 9;
            return _this._validateSignageBlock(isSubmit);
          case 9:
            isSigningValid = _context12.sent;
          case 10:
            if (isSigningValid) {
              _context12.next = 13;
              break;
            }
            window.scroll(0, 2500);
            return _context12.abrupt("return", false);
          case 13:
            _context12.next = 15;
            return _this._validateMasterForm();
          case 15:
            isFormValid = _context12.sent;
            if (isFormValid) {
              _context12.next = 19;
              break;
            }
            if (showLoader) {
              window.scroll(0, 0);
            }
            return _context12.abrupt("return", false);
          case 19:
            data = _objectSpread(_objectSpread({}, _this.state), {}, {
              signage: _objectSpread(_objectSpread({}, _this.state.signage), {}, {
                advisor: _objectSpread(_objectSpread({}, _this.state.signage.advisor), {}, {
                  datedOn: _this.state.signage.advisor.datedOn ? Services.dates.formatOutgoingDate(_this.state.signage.advisor.datedOn) : null
                }),
                authority: _objectSpread(_objectSpread({}, _this.state.signage.authority), {}, {
                  datedOn: _this.state.signage.authority.datedOn ? Services.dates.formatOutgoingDate(_this.state.signage.authority.datedOn) : null
                }),
                witness: _objectSpread(_objectSpread({}, _this.state.signage.witness), {}, {
                  datedOn: _this.state.signage.witness.datedOn ? Services.dates.formatOutgoingDate(_this.state.signage.witness.datedOn) : null
                })
              }),
              dependentsWithSurvivorBenefits: _this.state.dependentsWithSurvivorBenefits.map(function (dependent) {
                return _objectSpread(_objectSpread({}, dependent), {}, {
                  expiryDate: Services.dates.formatOutgoingDate(dependent.expiryDate)
                });
              }),
              employeesNotActivelyAtWork: _this.state.employeesNotActivelyAtWork.map(function (employee) {
                return _objectSpread(_objectSpread({}, employee), {}, {
                  dateLastAtWork: Services.dates.formatOutgoingDate(employee.dateLastAtWork),
                  expectedReturnDate: Services.dates.formatOutgoingDate(employee.expectedReturnDate)
                });
              }),
              contractEmployees: _this.state.contractEmployees.map(function (employee) {
                return _objectSpread(_objectSpread({}, employee), {}, {
                  contractEndDate: Services.dates.formatOutgoingDate(employee.contractEndDate),
                  contractStartDate: Services.dates.formatOutgoingDate(employee.contractStartDate)
                });
              })
            });
            delete data.modalTypeOpen;
            delete data.modalTitle;
            delete data.isEdit;
            delete data.currentItem;
            delete data.appSubmitted;
            delete data.reviewRequestSentSuccessDialogOpen;
            delete data.errors;
            delete data.lsaModal;
            delete data.hasLsa;

            // remove the blank banking fields
            delete data.eftDetails;
            delete data.bankingModal;

            // remove the form language
            delete data.locale;
            if (showLoader) {
              window.location.href = '#top';
            }
            _context12.next = 35;
            return _this.props.updateMasterApp(_this.props.currentAccountMeta.accountID, data, showLoader, showSuccess);
          case 35:
            success = _context12.sent;
            if (!success) {
              _context12.next = 38;
              break;
            }
            return _context12.abrupt("return", true);
          case 38:
            return _context12.abrupt("return", false);
          case 39:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    })), _this._saveAndSubmit = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
      var isFormValid;
      return _regenerator["default"].wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return _this._save(true, false, true);
          case 2:
            isFormValid = _context13.sent;
            if (!isFormValid) {
              _context13.next = 5;
              break;
            }
            return _context13.abrupt("return", _this._completeMasterApp());
          case 5:
            return _context13.abrupt("return", false);
          case 6:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    })), _this._sendForApproval = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
      var isValid, success;
      return _regenerator["default"].wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return _this._validateSignageBlock();
          case 2:
            isValid = _context14.sent;
            if (isValid) {
              _context14.next = 5;
              break;
            }
            return _context14.abrupt("return", false);
          case 5:
            _context14.next = 7;
            return _this.props.sendRequestApprovalLink(_this.props.currentAccountMeta.accountID);
          case 7:
            success = _context14.sent;
            if (!success) {
              _context14.next = 11;
              break;
            }
            _this.setState({
              reviewRequestSentSuccessDialogOpen: true
            });
            return _context14.abrupt("return", true);
          case 11:
            return _context14.abrupt("return", false);
          case 12:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    })), _this._saveAndSendForApproval = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15() {
      var isFormValid;
      return _regenerator["default"].wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return _this._save(true, false, true);
          case 2:
            isFormValid = _context15.sent;
            if (!isFormValid) {
              _context15.next = 5;
              break;
            }
            return _context15.abrupt("return", _this._sendForApproval());
          case 5:
            return _context15.abrupt("return", false);
          case 6:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    })), _this._submitAuthorityView = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16() {
      var isValid, data, success;
      return _regenerator["default"].wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return _this._validateSignageBlock();
          case 2:
            isValid = _context16.sent;
            if (isValid) {
              _context16.next = 5;
              break;
            }
            return _context16.abrupt("return", false);
          case 5:
            data = _objectSpread(_objectSpread({}, _this.state), {}, {
              signage: _objectSpread(_objectSpread({}, _this.state.signage), {}, {
                advisor: _objectSpread(_objectSpread({}, _this.state.signage.advisor), {}, {
                  datedOn: _this.state.signage.advisor.datedOn ? Services.dates.formatOutgoingDate(_this.state.signage.advisor.datedOn) : null
                }),
                authority: _objectSpread(_objectSpread({}, _this.state.signage.authority), {}, {
                  datedOn: _this.state.signage.authority.datedOn ? Services.dates.formatOutgoingDate(_this.state.signage.authority.datedOn) : null
                }),
                witness: _objectSpread(_objectSpread({}, _this.state.signage.witness), {}, {
                  datedOn: _this.state.signage.witness.datedOn ? Services.dates.formatOutgoingDate(_this.state.signage.witness.datedOn) : null
                })
              }),
              bankingAccountHolder: _this.state.eftDetails["default"].accountHolder,
              bankingInstitutionName: _this.state.eftDetails["default"].institutionName,
              bankingInstitutionAddress: _this.state.eftDetails["default"].institutionAddress,
              bankingInstitutionNum: _this.state.eftDetails["default"].institutionNum,
              bankingTransitNum: _this.state.eftDetails["default"].transitNum,
              bankingAccountNum: _this.state.eftDetails["default"].accountNum,
              bankingAccepted: _this.state.eftDetails["default"].accepted,
              bankingTimestampOfAcceptance: _this.state.eftDetails["default"].timestampOfAcceptance
            });
            delete data.modalTypeOpen;
            delete data.modalTitle;
            delete data.isEdit;
            delete data.currentItem;
            delete data.appSubmitted;
            delete data.reviewRequestSentSuccessDialogOpen;
            delete data.errors;
            delete data.lsaModal;
            delete data.hasLsa;

            // remove the extra banking fields
            delete data.bankingDetails;
            delete data.bankingModal;
            delete data.eftDetails;
            _context16.next = 20;
            return _this.props.submitMasterApp(_this.props.currentAccountMeta.accountID, data);
          case 20:
            success = _context16.sent;
            if (!success) {
              _context16.next = 24;
              break;
            }
            _this.setState({
              appSubmitted: true
            });
            return _context16.abrupt("return", true);
          case 24:
            return _context16.abrupt("return", false);
          case 25:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    })), _this._saveNewBankingDetails = function (newBankingDetails) {
      _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        eftDetails: _objectSpread({}, newBankingDetails)
      }));
    }, _this._handleEditBankingDetails = function () {
      _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        eftDetails: {
          "default": _objectSpread(_objectSpread({}, _this.state.eftDetails["default"]), {}, {
            isValidated: false
          })
        }
      }));
      _this._toggle("bankingModal");
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(MasterAppForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$plan,
        _this2 = this;
      var hasLsa = (_this$props$plan = this.props.plan) === null || _this$props$plan === void 0 ? void 0 : _this$props$plan.spendingAccounts.some(function (d) {
        var _d$coverage, _d$coverage2;
        return ((_d$coverage = d.coverage) === null || _d$coverage === void 0 ? void 0 : _d$coverage.includeLsa) === true || ((_d$coverage2 = d.coverage) === null || _d$coverage2 === void 0 ? void 0 : _d$coverage2.isPooled) === true;
      });
      this.setState({
        hasLsa: hasLsa
      });

      // don't auto save when its the authority review screen
      if (this.props.isAuthorityView) {
        return null;
      }
      var initState = this.state;

      // auto save form every 20 seconds
      this._timer = setInterval(function () {
        // don't save if the modal is open
        if (_this2.state.modalTypeOpen) {
          return;
        }
        if (initState !== _this2.state) {
          _this2._save(false, false, false);
          initState = _objectSpread({}, _this2.state);
        }
      }, 20000);
      return null;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this._timer);
    }

    /**
     * Open the modal and set the current currentItem based on the type of modal we are opening
     * If its an edit, we need the uuid so we know which item we are changing
     * @param type
     * @param isEdit
     * @param uuid
     * @private
     */

    // on any change, if the signage block has been set, unset it and make them re-sign the doc

    /**
     * Set next step to false so we go back to the Index
     **/
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
        _this$state$errors$cu,
        _this$state$errors$cu2,
        _this$state$errors$cu3,
        _this$state$errors$cu4,
        _this$state$errors$cu5,
        _this$state$errors$cu6,
        _this$state$errors$cu7,
        _this$state$errors$cu8,
        _this$state$errors$cu9,
        _this$state$errors$cu10,
        _this$state$errors$cu11,
        _this$state$errors$cu12,
        _this$state$errors$cu13,
        _this$state$errors$cu14,
        _this$state$errors$cu15,
        _this$state$errors$cu16;
      var _this$props = this.props,
        isReadOnly = _this$props.isReadOnly,
        whitelabel = _this$props.whitelabel;
      var isAuthorityView = Boolean(this.props.isAuthorityView);
      var styles = {
        saveAndSendBtn: {
          marginRight: 1
        },
        signageAcceptBox: {
          paddingTop: '0',
          marginTop: '-15px',
          paddingRight: "8px",
          paddingLeft: "8px",
          paddingBottom: "8px"
        },
        signature: {
          fontFamily: 'AntaraDistance',
          fontWeight: 'bold',
          fontSize: 20,
          paddingBottom: 0
        },
        row: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-around',
          width: '100%'
        },
        column: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          marginTop: 20
        },
        goBack: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          backgroundColor: 'rgb(247, 247, 247)'
        },
        spacer: {
          // 15 pixels for Eric
          height: 15
        },
        chip: {
          margin: 3
        },
        formLabel: {
          fontFamily: Theme.fonts.type.light
        },
        gridStyle: {
          padding: "8px",
          flex: 1
        },
        signStyle: {
          "& .MuiInput-underline:hover:not(.Mui-disabled):not(.Mui-error):before": {
            borderBottomWidth: "2px"
          }
        },
        errorStyle: {
          "&. MuiFormHelperText-root.Mui-error": {
            marginLeft: "0px"
          }
        }
      };
      if (isReadOnly) {
        isAuthorityView = true;
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        id: "top"
      }), this.state.appSubmitted || isReadOnly ? null : isAuthorityView ? /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.masterApplication.reviewAndSignApplication),
        subtitle: _i18n["default"].t(_tokens["default"].labels.masterApplication.reviewMasterApplication),
        btn: true,
        btnName: _i18n["default"].t(_tokens["default"].buttons.submit),
        btnOnClick: this._submitAuthorityView
      }) : this.props.sendRequestApprovalLink ? /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.masterApplication.sendForApproval),
        subtitle: _i18n["default"].t(_tokens["default"].labels.masterApplication.reviewFinalizedMasterApplication),
        btn: true,
        btnName: _i18n["default"].t(_tokens["default"].buttons.sendForApproval),
        btnOnClick: this._saveAndSendForApproval,
        btnsAbove: true
      }) : /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.masterApplication.completeAndSubmit),
        subtitle: _i18n["default"].t(_tokens["default"].labels.masterApplication.completeTheMasterApplication),
        btn: this.props.currentAccountMeta.state < 3,
        btnName: _i18n["default"].t(_tokens["default"].buttons.submit),
        btnOnClick: this._saveAndSubmit,
        btnsAbove: true
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          backgroundColor: _colors["default"].surface,
          boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
          display: 'block',
          margin: 'auto auto 30px auto',
          padding: '22px',
          position: 'relative',
          zIndex: 3
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        display: "block",
        align: "left",
        margin: "20px 8px 20px 8px",
        customLinkStyle: {
          lineHeight: '40px'
        }
      }, _i18n["default"].t(_tokens["default"].labels.masterApplication.groupApplicantsData)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 6
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.companyName),
        value: this.state.company,
        onBlur: function onBlur() {
          return _this3._onBlur('company');
        },
        onChange: this._handleChange('company'),
        error: Boolean(this.state.errors.companyError),
        disabled: isAuthorityView,
        fullWidth: true,
        required: true
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 6
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.totalLivesToBeInsured),
        fullWidth: true,
        required: true,
        value: this.state.numLives,
        onBlur: function onBlur() {
          return _this3._onBlur('numLives');
        },
        onChange: this._handleChange('numLives'),
        error: Boolean(this.state.errors.numLivesError),
        disabled: isAuthorityView
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.companyAddress),
        fullWidth: true,
        required: true,
        value: this.state.address,
        onBlur: function onBlur() {
          return _this3._onBlur('address');
        },
        onChange: this._handleChange('address'),
        error: Boolean(this.state.errors.addressError),
        helperText: this.state.errors.addressError,
        disabled: isAuthorityView
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.natureOfBusiness),
        fullWidth: true,
        required: true,
        value: this.state.nature,
        onBlur: function onBlur() {
          return _this3._onBlur('nature');
        },
        onChange: this._handleChange('nature'),
        error: Boolean(this.state.errors.natureError),
        helperText: this.state.errors.natureError,
        disabled: isAuthorityView
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 7
      }, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        component: "fieldset",
        error: Boolean(this.state.errors.categoriesError)
      }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
        sx: styles.formLabel,
        component: "legend",
        required: true
      }, _i18n["default"].t(_tokens["default"].labels.masterApplication.businessIs)), /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        row: true
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        disabled: isAuthorityView,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.categories.indexOf('corporation') > -1,
          onChange: function onChange() {
            return _this3._handleCategoryChange('corporation');
          },
          value: "corporation",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          customStyle: isAuthorityView ? {
            color: "rgba(0, 0, 0, 0.38)"
          } : {},
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].labels.masterApplication.corporation))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        disabled: isAuthorityView,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.categories.indexOf('partnership') > -1,
          onChange: function onChange() {
            return _this3._handleCategoryChange('partnership');
          },
          value: "partnership",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          customStyle: isAuthorityView ? {
            color: "rgba(0, 0, 0, 0.38)"
          } : {},
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].labels.masterApplication.partnership))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        disabled: isAuthorityView,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.categories.indexOf('sole proprietorship') > -1,
          onChange: function onChange() {
            return _this3._handleCategoryChange('sole proprietorship');
          },
          value: "sole proprietorship",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          customStyle: isAuthorityView ? {
            color: "rgba(0, 0, 0, 0.38)"
          } : {},
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].labels.masterApplication.soleProprietorship))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        disabled: isAuthorityView,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.categories.indexOf('unionized') > -1,
          onChange: function onChange() {
            return _this3._handleCategoryChange('unionized');
          },
          value: "unionized",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          customStyle: isAuthorityView ? {
            color: "rgba(0, 0, 0, 0.38)"
          } : {},
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].labels.masterApplication.unionized))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        disabled: isAuthorityView,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.categories.indexOf('joint venture') > -1,
          onChange: function onChange() {
            return _this3._handleCategoryChange('joint venture');
          },
          value: "joint venture",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          customStyle: isAuthorityView ? {
            color: "rgba(0, 0, 0, 0.38)"
          } : {},
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].labels.masterApplication.jointVenture))
      })), this.state.errors.categoriesError && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        color: "#d93025",
        display: "block",
        align: "left"
      }, this.state.errors.categoriesError))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: this.state.hasExistingCoverage ? 4 : 12
      }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
        sx: styles.formLabel
      }, _i18n["default"].t(_tokens["default"].labels.masterApplication.existingGroupBenefits)), /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        row: true
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        disabled: isAuthorityView,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.hasExistingCoverage,
          onChange: function onChange() {
            return _this3._toggle('hasExistingCoverage');
          },
          value: "hasExistingCoverage",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          customStyle: isAuthorityView ? {
            color: "rgba(0, 0, 0, 0.38)"
          } : {},
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].labels.masterApplication.applicantHasExistingGroupBenefits))
      }))), this.state.hasExistingCoverage && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.employeesCurrentlyInsured),
        fullWidth: true,
        required: true,
        value: this.state.numEmployeesInsured,
        onBlur: function onBlur() {
          return _this3._onBlur('numEmployeesInsured');
        },
        onChange: this._handleChange('numEmployeesInsured'),
        error: Boolean(this.state.errors.numEmployeesInsuredError),
        disabled: isAuthorityView
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.employeesCoveredByWCBWSIB),
        fullWidth: true,
        required: true,
        value: this.state.numEmployeesCoveredByWCB,
        onBlur: function onBlur() {
          return _this3._onBlur('numEmployeesCoveredByWCB');
        },
        onChange: this._handleChange('numEmployeesCoveredByWCB'),
        error: Boolean(this.state.errors.numEmployeesCoveredByWCBError),
        disabled: isAuthorityView
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        row: true,
        onClick: function onClick() {
          return _this3._openModal('existingCoverage');
        }
      }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
        sx: styles.formLabel,
        error: Boolean(this.state.errors.existingCarrierError),
        required: true
      }, _i18n["default"].t(_tokens["default"].labels.masterApplication.existingCarrier)), !isAuthorityView && /*#__PURE__*/_react["default"].createElement(_Add["default"], {
        style: {
          fontSize: 19,
          marginTop: 2.5
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: 10
        }
      }, this.state.existingCoverage.length === 0 ? /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _i18n["default"].t(_tokens["default"].labels.masterApplication.none)) : this.state.existingCoverage.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_ExistingCoverageBlock["default"], {
          key: item.uuid,
          data: item,
          remove: function remove() {
            return _this3._removeArrayItem('existingCoverage', item.uuid);
          },
          edit: function edit() {
            return _this3._openModal('existingCoverage', true, item.uuid);
          },
          isAuthorityView: isAuthorityView
        });
      })))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        row: true,
        onClick: function onClick() {
          return _this3._openModal('dependentsWithSurvivorBenefits');
        }
      }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
        sx: styles.formLabel
      }, _i18n["default"].t(_tokens["default"].labels.masterApplication.dependentsWithSurvivorBenefits)), !isAuthorityView && /*#__PURE__*/_react["default"].createElement(_Add["default"], {
        style: {
          fontSize: 19,
          marginTop: 2.5
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: 10
        }
      }, this.state.dependentsWithSurvivorBenefits.length === 0 ? /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _i18n["default"].t(_tokens["default"].labels.masterApplication.none)) : this.state.dependentsWithSurvivorBenefits.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_SurvivorBenefitDependentRow["default"], {
          key: item.uuid,
          data: item,
          remove: function remove() {
            return _this3._removeArrayItem('dependentsWithSurvivorBenefits', item.uuid);
          },
          edit: function edit() {
            return _this3._openModal('dependentsWithSurvivorBenefits', true, item.uuid);
          },
          isAuthorityView: isAuthorityView
        });
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        row: true,
        onClick: function onClick() {
          return _this3._openModal('employeesNotActivelyAtWork');
        }
      }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
        sx: styles.formLabel
      }, _i18n["default"].t(_tokens["default"].labels.masterApplication.employeesNotAtWork)), !isAuthorityView && /*#__PURE__*/_react["default"].createElement(_Add["default"], {
        style: {
          fontSize: 19,
          marginTop: 2.5
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: 10
        }
      }, this.state.employeesNotActivelyAtWork.length === 0 ? /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _i18n["default"].t(_tokens["default"].labels.masterApplication.none)) : this.state.employeesNotActivelyAtWork.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_EmployeeNotAtWorkRow["default"], {
          key: item.uuid,
          data: item,
          remove: function remove() {
            return _this3._removeArrayItem('employeesNotActivelyAtWork', item.uuid);
          },
          edit: function edit() {
            return _this3._openModal('employeesNotActivelyAtWork', true, item.uuid);
          },
          isAuthorityView: isAuthorityView
        });
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        row: true,
        onClick: function onClick() {
          return _this3._openModal('contractEmployees');
        }
      }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
        sx: styles.formLabel
      }, _i18n["default"].t(_tokens["default"].labels.masterApplication.contractEmployees)), !isAuthorityView && /*#__PURE__*/_react["default"].createElement(_Add["default"], {
        style: {
          fontSize: 19,
          marginTop: 2.5
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: 10
        }
      }, this.state.contractEmployees.length === 0 ? /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _i18n["default"].t(_tokens["default"].labels.masterApplication.none)) : this.state.contractEmployees.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_ContractEmployeeRow["default"], {
          key: item.uuid,
          data: item,
          remove: function remove() {
            return _this3._removeArrayItem('contractEmployees', item.uuid);
          },
          edit: function edit() {
            return _this3._openModal('contractEmployees', true, item.uuid);
          },
          isAuthorityView: isAuthorityView
        });
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        row: true,
        onClick: function onClick() {
          return _this3._openModal('exclusionsFromCoverage');
        }
      }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
        sx: styles.formLabel
      }, _i18n["default"].t(_tokens["default"].labels.masterApplication.excludedFromGroupBenefits)), !isAuthorityView && /*#__PURE__*/_react["default"].createElement(_Add["default"], {
        style: {
          fontSize: 19,
          marginTop: 2.5
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: 10
        }
      }, this.state.exclusionsFromCoverage.length === 0 ? /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _i18n["default"].t(_tokens["default"].labels.masterApplication.none)) : this.state.exclusionsFromCoverage.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_ExcludedFromBenefitsRow["default"], {
          key: item.uuid,
          data: item,
          remove: function remove() {
            return _this3._removeArrayItem('exclusionsFromCoverage', item.uuid);
          },
          edit: function edit() {
            return _this3._openModal('exclusionsFromCoverage', true, item.uuid);
          },
          isAuthorityView: isAuthorityView
        });
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: this.state.stopLoss.status ? 3 : 12
      }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
        sx: styles.formLabel
      }, _i18n["default"].t(_tokens["default"].labels.masterApplication.stopLoss)), /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        row: true
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        disabled: isAuthorityView,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.stopLoss.status,
          onChange: function onChange() {
            return _this3._toggle('stopLoss', 'status');
          },
          disabled: isAuthorityView,
          value: "hasStopLoss",
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          customStyle: isAuthorityView ? {
            color: "rgba(0, 0, 0, 0.38)"
          } : {},
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].labels.masterApplication.applicantHasStopLoss))
      }))), this.state.stopLoss.status && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.stopLossLevel),
        fullWidth: true,
        required: true,
        value: this.state.stopLoss.amount,
        onBlur: function onBlur() {
          return _this3._onBlur('stopLossAmount');
        },
        onChange: this._handleChange('stopLoss', 'amount'),
        error: Boolean(this.state.errors.stopLossAmountError),
        prefix: true,
        disabled: isAuthorityView
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 5
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        disabled: isAuthorityView,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.stopLoss.insuredsWithRecurringClaims,
          onChange: function onChange() {
            return _this3._toggle('stopLoss', 'insuredsWithRecurringClaims');
          },
          value: "insuredsWithRecurringClaims",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          customStyle: isAuthorityView ? {
            color: "rgba(0, 0, 0, 0.38)"
          } : {},
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].labels.masterApplication.recurringEHCClaims))
      }))), isAuthorityView && this.state.hasLsa && !isReadOnly && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], null, _i18n["default"].t(_tokens["default"].labels.spendingAccounts.lifestyleSpendingAccount)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.masterApplication.lifestyleSpendingAccount)), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        marginTop: "20px",
        onClick: function onClick() {
          return _this3._toggle("lsaModal");
        },
        color: "primary"
      }, _i18n["default"].t(_tokens["default"].buttons.selectItems)))), this.state.hasLsa && this.state.lsaItems && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.masterApplication.selectedLifestyleItems)), this.state.lsaItems.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
          key: item,
          label: localizationMaps.fromEnglish("benefits", item),
          onDelete: isReadOnly ? false : function () {
            return _this3._removeLsaItem(item);
          },
          variant: "default",
          style: styles.chip
        });
      }))), isAuthorityView && !isReadOnly && this.state.lsaModal && /*#__PURE__*/_react["default"].createElement(_LsaSelectionModal["default"], {
        open: Boolean(this.state.lsaModal),
        close: function close() {
          return _this3._toggle("lsaModal");
        },
        onBack: function onBack() {
          return _this3._toggle("lsaModal");
        },
        items: this.state.lsaItems,
        isMasterApp: true,
        onSave: this.saveLsaItems
      }), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.notes),
        fullWidth: true,
        multiline: true,
        rowsMax: 5,
        value: this.state.notes,
        onBlur: function onBlur() {
          return _this3._onBlur('notes');
        },
        onChange: this._handleChange('notes'),
        disabled: isAuthorityView
      })), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isAuthorityView && !isReadOnly && !this.state.bankingInstitutionName && this.props.currentAccountMeta.status !== 3 && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        style: styles.saveAndSendBtn,
        onClick: this._handleEditBankingDetails,
        color: "primary"
      }, this.state.eftDetails["default"].accepted ? _i18n["default"].t(_tokens["default"].buttons.editBankingDetails) : _i18n["default"].t(_tokens["default"].buttons.addBankingDetails))), isAuthorityView && !isReadOnly && this.props.currentAccountMeta.status !== 3 && this.state.bankingModal && /*#__PURE__*/_react["default"].createElement(_.EditBankingDetails, {
        modalOpen: this.state.bankingModal,
        accountLevelBankingDetailsView: true,
        validateBankingDetails: this.props.validateBankingDetails,
        close: function close() {
          return _this3._toggle("bankingModal");
        },
        saveNewBankingDetails: this._saveNewBankingDetails,
        closeModalAfterSaving: true,
        bankingDetailsVerifying: this.props.bankingDetailsVerifying
      }), this.state.eftDetails["default"].accepted && this.props.currentAccountMeta.status !== 3 && /*#__PURE__*/_react["default"].createElement(_DisplayBankingDetails["default"], {
        accountHolder: this.state.eftDetails["default"].accountHolder,
        accountNum: this.state.eftDetails["default"].accountNum,
        institutionAddress: this.state.eftDetails["default"].institutionAddress,
        institutionName: this.state.eftDetails["default"].institutionName,
        institutionNum: this.state.eftDetails["default"].institutionNum,
        transitNum: this.state.eftDetails["default"].transitNum,
        accepted: this.state.eftDetails["default"].accepted
      })), (this.props.isPrivateLabelAdvisor || this.props.currentAccountMeta.state >= 6) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.advisorSignature),
        fullWidth: true,
        required: true,
        value: this.state.signage.advisor.signature,
        onChange: function onChange(e) {
          return _this3._handleSignageBlockChange('advisor', 'signature', e.target.value);
        },
        inputProps: {
          inputProps: {
            style: _objectSpread({}, styles.signature)
          }
        },
        disabled: isAuthorityView,
        error: this.state.errors.advisorSignatureError,
        customStyle: styles.signStyle
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.advisorName),
        fullWidth: true,
        required: true,
        value: this.state.signage.advisor.name,
        onChange: function onChange(e) {
          return _this3._handleSignageBlockChange('advisor', 'name', e.target.value);
        },
        disabled: isAuthorityView,
        error: this.state.errors.advisorNameError,
        customStyle: styles.signStyle
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.advisorDatedOn),
        fullWidth: true,
        required: true,
        value: this.state.signage.advisor.datedOn,
        onChange: function onChange(e) {
          return _this3._handleSignageBlockChange('advisor', 'datedOn', e.target.value);
        },
        disabled: isAuthorityView,
        error: this.state.errors.advisorDatedOnError,
        customStyle: styles.signStyle
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sx: styles.signageAcceptBox
      }, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        row: true
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.signage.advisor.acceptedTerms,
          onChange: function onChange() {
            return _this3._handleSignageBlockChange('advisor', 'acceptedTerms', !_this3.state.signage.advisor.acceptedTerms);
          },
          value: "advisorAcceptedTerms",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          avMedium: true,
          color: "inherit"
        }, _i18n["default"].t(_tokens["default"].labels.masterApplication.advisorAcknowledgment))
      })), this.state.errors.advisorAcceptedTermsError && /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
        sx: {
          marginLeft: "0px"
        },
        error: true
      }, _i18n["default"].t(_tokens["default"].labels.banking.youMustAcceptTermsError)))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.authoritySignature),
        fullWidth: true,
        value: this.state.signage.authority.signature,
        onChange: function onChange(e) {
          return _this3._handleSignageBlockChange('authority', 'signature', e.target.value);
        },
        inputProps: {
          inputProps: {
            style: _objectSpread({}, styles.signature)
          }
        },
        disabled: !isAuthorityView || isReadOnly,
        error: this.state.errors.authoritySignatureError,
        customStyle: styles.signStyle
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.authorityName),
        fullWidth: true,
        value: this.state.signage.authority.name,
        onChange: function onChange(e) {
          return _this3._handleSignageBlockChange('authority', 'name', e.target.value);
        },
        disabled: !isAuthorityView || isReadOnly,
        error: this.state.errors.authorityNameError,
        customStyle: styles.signStyle
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.authorityDatedOn),
        fullWidth: true,
        value: this.state.signage.authority.datedOn,
        onChange: function onChange(e) {
          return _this3._handleSignageBlockChange('authority', 'datedOn', e.target.value);
        },
        disabled: !isAuthorityView || isReadOnly,
        error: this.state.errors.authorityDatedOnError,
        customStyle: styles.signStyle
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sx: styles.signageAcceptBox
      }, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        row: true
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.signage.authority.acceptedTerms,
          onChange: function onChange() {
            return _this3._handleSignageBlockChange('authority', 'acceptedTerms', !_this3.state.signage.authority.acceptedTerms);
          },
          value: "authorityAcceptedTerms",
          disabled: !isAuthorityView || isReadOnly,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          avMedium: true,
          color: "inherit"
        }, _i18n["default"].t(_tokens["default"].labels.masterApplication.authorityAcknowledgment))
      })), this.state.errors.authorityAcceptedTermsError && /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
        sx: {
          marginLeft: "0px"
        },
        error: true
      }, _i18n["default"].t(_tokens["default"].labels.banking.youMustAcceptTermsError)))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.witnessSignature),
        fullWidth: true,
        value: this.state.signage.witness.signature,
        onChange: function onChange(e) {
          return _this3._handleSignageBlockChange('witness', 'signature', e.target.value);
        },
        inputProps: {
          inputProps: {
            style: _objectSpread({}, styles.signature)
          }
        },
        disabled: !isAuthorityView || isReadOnly,
        error: this.state.errors.witnessSignatureError,
        customStyle: styles.signStyle
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.witnessName),
        fullWidth: true,
        value: this.state.signage.witness.name,
        onChange: function onChange(e) {
          return _this3._handleSignageBlockChange('witness', 'name', e.target.value);
        },
        disabled: !isAuthorityView || isReadOnly,
        error: this.state.errors.witnessNameError,
        customStyle: styles.signStyle
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: styles.gridStyle,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.witnessDatedOn),
        fullWidth: true,
        value: this.state.signage.witness.datedOn,
        onChange: function onChange(e) {
          return _this3._handleSignageBlockChange('witness', 'datedOn', e.target.value);
        },
        disabled: !isAuthorityView || isReadOnly,
        error: this.state.errors.witnessDatedOnError,
        customStyle: styles.signStyle
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sx: styles.signageAcceptBox
      }, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        row: true
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.signage.witness.acceptedTerms,
          onChange: function onChange() {
            return _this3._handleSignageBlockChange('witness', 'acceptedTerms', !_this3.state.signage.witness.acceptedTerms);
          },
          value: "witnessAcceptedTerms",
          disabled: !isAuthorityView || isReadOnly,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          avMedium: true,
          color: "inherit"
        }, _i18n["default"].t(_tokens["default"].labels.masterApplication.witnessAcknowledgment))
      })), this.state.errors.witnessAcceptedTermsError && /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
        sx: {
          marginLeft: "0px"
        },
        error: true
      }, _i18n["default"].t(_tokens["default"].labels.banking.youMustAcceptTermsError)))))), !this.props.isPrivateLabelAdvisor && !isAuthorityView && this.props.currentAccountMeta.state <= 3 && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        sx: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: 2
        }
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        customStyle: styles.saveAndSendBtn,
        onClick: this._saveAndSubmit,
        color: "primary"
      }, _i18n["default"].t(_tokens["default"].buttons.saveAndSubmit)), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return _this3._save(true, true, true);
        },
        color: "primary"
      }, _i18n["default"].t(_tokens["default"].buttons.save))), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: Boolean(this.state.modalTypeOpen),
        close: this._closeModal,
        title: this.state.modalTitle,
        buttonAction: this.state.isEdit ? this._updateArrayItem : this._addArrayItem,
        onSave: this.state.isEdit ? this._updateArrayItem : this._addArrayItem,
        customContainerStyle: {
          maxWidth: "500px"
        }
      }, this.state.modalTypeOpen === 'dependentsWithSurvivorBenefits' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.dependentName),
        value: this.state.currentItem.name,
        onBlur: function onBlur() {
          return _this3._modalFormItemBlur('name');
        },
        onChange: this._handleModalFormItemChange('name'),
        error: Boolean((_this$state$errors$cu = this.state.errors.currentModal) === null || _this$state$errors$cu === void 0 ? void 0 : _this$state$errors$cu.nameError),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.expiryDate),
        value: this.state.currentItem.expiryDate,
        onBlur: function onBlur() {
          return _this3._onBlurDate('expiryDate', false, true);
        },
        onChange: this._handleModalFormItemChange('expiryDate'),
        error: Boolean((_this$state$errors$cu2 = this.state.errors.currentModal) === null || _this$state$errors$cu2 === void 0 ? void 0 : _this$state$errors$cu2.expiryDateError),
        fullWidth: true
      })), this.state.modalTypeOpen === 'employeesNotActivelyAtWork' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.employeeName),
        value: this.state.currentItem.name,
        onBlur: function onBlur() {
          return _this3._modalFormItemBlur('name');
        },
        onChange: this._handleModalFormItemChange('name'),
        error: Boolean((_this$state$errors$cu3 = this.state.errors.currentModal) === null || _this$state$errors$cu3 === void 0 ? void 0 : _this$state$errors$cu3.nameError),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.dateLastWorked),
        value: this.state.currentItem.dateLastAtWork,
        onBlur: function onBlur() {
          return _this3._onBlurDate('dateLastAtWork', true, true);
        },
        onChange: this._handleModalFormItemChange('dateLastAtWork'),
        error: Boolean((_this$state$errors$cu4 = this.state.errors.currentModal) === null || _this$state$errors$cu4 === void 0 ? void 0 : _this$state$errors$cu4.dateLastAtWorkError),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.expectedReturnDate),
        value: this.state.currentItem.expectedReturnDate,
        onBlur: function onBlur() {
          return _this3._onBlurDate('expectedReturnDate', false, true);
        },
        onChange: this._handleModalFormItemChange('expectedReturnDate'),
        error: Boolean((_this$state$errors$cu5 = this.state.errors.currentModal) === null || _this$state$errors$cu5 === void 0 ? void 0 : _this$state$errors$cu5.expectedReturnDateError),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.reason),
        value: this.state.currentItem.reasonNotAtWork,
        onBlur: function onBlur() {
          return _this3._modalFormItemBlur('reasonNotAtWork');
        },
        onChange: this._handleModalFormItemChange('reasonNotAtWork'),
        error: Boolean((_this$state$errors$cu6 = this.state.errors.currentModal) === null || _this$state$errors$cu6 === void 0 ? void 0 : _this$state$errors$cu6.reasonNotAtWorkError),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.claimStatus),
        value: this.state.currentItem.claimStatus,
        onBlur: function onBlur() {
          return _this3._modalFormItemBlur('claimStatus');
        },
        onChange: this._handleModalFormItemChange('claimStatus'),
        error: Boolean((_this$state$errors$cu7 = this.state.errors.currentModal) === null || _this$state$errors$cu7 === void 0 ? void 0 : _this$state$errors$cu7.claimStatusError),
        fullWidth: true
      })), this.state.modalTypeOpen === 'contractEmployees' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.employeeName),
        value: this.state.currentItem.name,
        onBlur: function onBlur() {
          return _this3._modalFormItemBlur('name');
        },
        onChange: this._handleModalFormItemChange('name'),
        error: Boolean((_this$state$errors$cu8 = this.state.errors.currentModal) === null || _this$state$errors$cu8 === void 0 ? void 0 : _this$state$errors$cu8.nameError),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.occupation),
        value: this.state.currentItem.occupation,
        onBlur: function onBlur() {
          return _this3._modalFormItemBlur('occupation');
        },
        onChange: this._handleModalFormItemChange('occupation'),
        error: Boolean((_this$state$errors$cu9 = this.state.errors.currentModal) === null || _this$state$errors$cu9 === void 0 ? void 0 : _this$state$errors$cu9.occupationError),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.contractStartDate),
        value: this.state.currentItem.contractStartDate,
        onBlur: function onBlur() {
          return _this3._onBlurDate('contractStartDate', true, true);
        },
        onChange: this._handleModalFormItemChange('contractStartDate'),
        error: Boolean((_this$state$errors$cu10 = this.state.errors.currentModal) === null || _this$state$errors$cu10 === void 0 ? void 0 : _this$state$errors$cu10.contractStartDateError),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.contractEndDate),
        value: this.state.currentItem.contractEndDate,
        onBlur: function onBlur() {
          return _this3._onBlurDate('contractEndDate', false, true);
        },
        onChange: this._handleModalFormItemChange('contractEndDate'),
        error: Boolean((_this$state$errors$cu11 = this.state.errors.currentModal) === null || _this$state$errors$cu11 === void 0 ? void 0 : _this$state$errors$cu11.contractEndDateError),
        fullWidth: true
      })), this.state.modalTypeOpen === 'exclusionsFromCoverage' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.employeeNameCategory),
        value: this.state.currentItem.name,
        onBlur: function onBlur() {
          return _this3._modalFormItemBlur('name');
        },
        onChange: this._handleModalFormItemChange('name'),
        error: Boolean((_this$state$errors$cu12 = this.state.errors.currentModal) === null || _this$state$errors$cu12 === void 0 ? void 0 : _this$state$errors$cu12.nameError),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.reason),
        value: this.state.currentItem.reasonForExclusion,
        onBlur: function onBlur() {
          return _this3._modalFormItemBlur('reasonForExclusion');
        },
        onChange: this._handleModalFormItemChange('reasonForExclusion'),
        error: Boolean((_this$state$errors$cu13 = this.state.errors.currentModal) === null || _this$state$errors$cu13 === void 0 ? void 0 : _this$state$errors$cu13.reasonForExclusionError),
        fullWidth: true
      })), this.state.modalTypeOpen === 'existingCoverage' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.masterApplication.nameOfInsurerCarrier),
        value: this.state.currentItem.carrier,
        onBlur: function onBlur() {
          return _this3._modalFormItemBlur('carrier');
        },
        onChange: this._handleModalFormItemChange('carrier'),
        error: Boolean((_this$state$errors$cu14 = this.state.errors.currentModal) === null || _this$state$errors$cu14 === void 0 ? void 0 : _this$state$errors$cu14.carrierError),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        component: "fieldset",
        style: {
          marginTop: 20
        },
        error: Boolean((_this$state$errors$cu15 = this.state.errors.currentModal) === null || _this$state$errors$cu15 === void 0 ? void 0 : _this$state$errors$cu15.benefitsError)
      }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
        sx: styles.formLabel,
        component: "legend"
      }, _i18n["default"].t(_tokens["default"].labels.masterApplication.benefitsCovered), ":"), /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        row: true
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.currentItem.benefits.indexOf('Basic Life') > -1,
          onChange: this._handleModalFormItemChange('benefits', 'Basic Life'),
          value: "basicLife",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].titles.basicLife))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.currentItem.benefits.indexOf('AD&D') > -1,
          onChange: this._handleModalFormItemChange('benefits', 'AD&D'),
          value: "add",
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].titles["ad&d"]))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.currentItem.benefits.indexOf('Dependent Life') > -1,
          onChange: this._handleModalFormItemChange('benefits', 'Dependent Life'),
          value: "dependentLife",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].titles.dependentLife))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.currentItem.benefits.indexOf('EHC') > -1,
          onChange: this._handleModalFormItemChange('benefits', 'EHC'),
          value: "ehc",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].titles.ehc))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.currentItem.benefits.indexOf('Dental') > -1,
          onChange: this._handleModalFormItemChange('benefits', 'Dental'),
          value: "dental",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].titles.dental))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.currentItem.benefits.indexOf('STD') > -1,
          onChange: this._handleModalFormItemChange('benefits', 'STD'),
          value: "std",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].titles.std))
      }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.currentItem.benefits.indexOf('LTD') > -1,
          onChange: this._handleModalFormItemChange('benefits', 'LTD'),
          value: "ltd",
          disabled: isAuthorityView,
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].titles.ltd))
      })), ((_this$state$errors$cu16 = this.state.errors.currentModal) === null || _this$state$errors$cu16 === void 0 ? void 0 : _this$state$errors$cu16.benefitsError) && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        color: "#d93025",
        display: "block",
        align: "left"
      }, this.state.errors.currentModal.benefitsError)))), this.state.reviewRequestSentSuccessDialogOpen && /*#__PURE__*/_react["default"].createElement(_StepCompletionNotif["default"], {
        dialog: _i18n["default"].t(_tokens["default"].labels.masterApplication.submissionSuccess),
        type: _i18n["default"].t(_tokens["default"].titles.masterApplication),
        open: Boolean(this.state.reviewRequestSentSuccessDialogOpen),
        handleClose: this._closeReviewRequestSentSuccessDialog,
        handleNext: this._goToNextStep,
        disableBackdropClick: true,
        disableEscapeKeyDown: true
      }), this.state.modalTypeOpen === "checkBoxModal" && /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.modalTypeOpen === "checkBoxModal",
        close: function close() {
          return _this3._toggleModal(false);
        },
        title: "Please confirm changes.",
        onSave: function onSave() {
          return _this3._toggleModal(false);
        },
        saveButtonText: "Close"
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        light: true,
        display: "block",
        align: "left",
        margin: "20px 0"
      }, _i18n["default"].t(_tokens["default"].labels.signage.pleaseAcceptAndAcknowledgeChanges)))));
    }
  }]);
  return MasterAppForm;
}(_react.PureComponent);
var _default = exports["default"] = MasterAppForm;